import {
   ChangeDetectionStrategy,
   Component,
   Inject,
   Input,
   Signal,
   signal,
   TemplateRef,
   ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
   LcsAdvancedMultiSelectComponent,
   LcsAdvancedMultiSelectStateBaseEventPayload,
} from '@lcs/shared/advanced-multi-select';
import { AdvancedMultiSelectBase } from 'src/app/common-components/multi-select/advanced-multi-select-base.directive';
import { ScheduleOption } from 'src/app/pages/schedule-register/models/schedule-option-interface';
import { scheduleOptionActions } from '../state/schedule-option.actions';
import { scheduleOptionSelectors } from '../state/schedule-option.reducer';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-schedule-advanced-multi-select',
    styleUrls: ['./schedule-advanced-multi-select.component.scss'],
    templateUrl: './schedule-advanced-multi-select.component.html',
    standalone: false
})
export class ScheduleAdvancedMultiSelectComponent extends AdvancedMultiSelectBase<ScheduleOption> {
   @Input() set accountIdFilter(value: number | null) {
      this.options.loadFilters = [value ? `AccountId = ${value}` : 'AccountId Is Null'];
   }

   @Input() set scheduleIdsToExclude(value: number[] | null) {
      this.options.loadFilters = [
         ...(this.options.loadFilters || []),
         ...(value ? [`ScheduleId Not In (${value})`] : []),
      ];
   }

   @ViewChild('trigger', { static: false }) triggerElement: LcsAdvancedMultiSelectComponent<ScheduleOption>;

   labelSignal: Signal<string> = signal('Schedules');

   @ViewChild('headerActionsTemplateRef', { static: false }) headerActionsTemplate: TemplateRef<any>;

   isEditing: boolean = false;

   isSaved: boolean = false;

   itemTrackBy = (schedule: ScheduleOption) => schedule.scheduleId;

   constructor(
      public dialogRef: MatDialogRef<ScheduleAdvancedMultiSelectComponent>,
      @Inject(MAT_DIALOG_DATA)
      private data: { accountIdFilter?: number; scheduleIdsToExclude?: number[]; isEditing: boolean }
   ) {
      super({
         loadAction: scheduleOptionActions.load,
         loadFilters: [],
         searchAction: scheduleOptionActions.search,
         searchResetAction: scheduleOptionActions.searchReset,
         selectFilteredItems: scheduleOptionSelectors.selectFilteredItems,
         selectCallState: scheduleOptionSelectors.selectCallState,
      });
      if (data?.accountIdFilter) {
         this.accountIdFilter = data.accountIdFilter;
      }
      if (data?.scheduleIdsToExclude) {
         this.scheduleIdsToExclude = data.scheduleIdsToExclude;
      }
      if (data?.isEditing) {
         this.isEditing = data.isEditing;
      }
   }

   ngAfterViewInit(): void {
      if (this.isEditing) {
         this.triggerElement.onOpenDialog();
      }
   }

   onSave(e: LcsAdvancedMultiSelectStateBaseEventPayload<ScheduleOption>): void {
      if (this.isEditing) {
         this.dialogRef.close(e.state.selectedItems());
      } else {
         super.onSave(e);
      }
      this.isSaved = true;
   }

   onCancel(e: LcsAdvancedMultiSelectStateBaseEventPayload<ScheduleOption>): void {
      if (this.isEditing) {
         if (!this.isSaved) {
            this.dialogRef.close();
         }
         return;
      }

      super.onClose(e);
   }

   isScheduleSelected(selectedSchedules: ScheduleOption[], schedule: ScheduleOption) {
      return selectedSchedules.some((r) => {
         return this.itemTrackBy(r) === this.itemTrackBy(schedule);
      });
   }
}
